"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Deployment_1 = require("./Deployment");
exports.Deployments = ({ template }) => {
    const params = new URLSearchParams(window.location.search);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.QueryList, { itemName: "deployment", itemsKey: "emailTemplateVersionDeployments", countKey: "emailTemplateVersionDeploymentCount", item: Deployment_1.Deployment, queryVariables: {
                emailTemplateId: template.id,
                versionId: params.get('version'),
            }, queryProps: {
                fetchPolicy: 'cache-and-network',
                query: graphql_1.emailTemplateVersionDeployments,
                variables: {
                    emailTemplateId: template.id,
                },
            } })));
};
//# sourceMappingURL=Deployments.js.map